import { z } from "zod"

const GeometrySchema = z.object({
    type: z.string(),
    coordinates: z.tuple([z.number(), z.number()]),
})

const PropertySchema = z.object({
    label: z.string(),
    score: z.number(),
    housenumber: z.string().optional(),
    id: z.string(),
    name: z.string(),
    postcode: z.string().optional(),
    citycode: z.string(),
    x: z.number(),
    y: z.number(),
    city: z.string(),
    context: z.string(),
    type: z.string(),
    importance: z.number(),
    street: z.string().optional(),
})

const FeatureSchema = z.object({
    type: z.string(),
    geometry: GeometrySchema,
    properties: PropertySchema,
})

export const AddressesResponseSchema = z.object({
    features: z.array(FeatureSchema).optional().prefault([]),
})

export type DataGouvAddressesResponse = z.infer<typeof AddressesResponseSchema>
